import MuiIconButton, { type IconButtonProps as MuiIconButtonProps } from "@mui/material/IconButton";

export type IconButtonProps = MuiIconButtonProps;

export function IconButton(props: IconButtonProps) {
  return <MuiIconButton {...props} />;
}
